import { useLoadingState } from '@ipfabric/ui-components/hooks/useLoadingState';
import { withLoadingIndicator } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import { CodeIcon } from 'components/icons/CodeIcon';
import { useLocale } from 'containers/App/LocaleContext';
import { useState } from 'react';
import type { FC } from 'react';
import { useApi } from 'utils/request/useApi';
import { GraphToolbarButton } from '../GraphToolbar/GraphToolbarButton';
import { GraphApiDocumentationModal } from './GraphApiDocumentationModal';

export interface GraphDocs {
  headers: string;
  payloadBase: string;
}

export const GraphApiDocumentation: FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [docs, setDocs] = useState<GraphDocs | null>(null);
  const [loadingState, setLoadingState] = useLoadingState();
  const apiRequest = useApi().request;
  const {
    canvasGraph: {
      graphToolbar: { buttons: msgButtons },
    },
  } = useLocale();

  const handleClick = async () => {
    if (docs === null) {
      const docsResponse = await withLoadingIndicator(setLoadingState)(() =>
        apiRequest<GraphDocs>({
          url: '/docs/graphs',
          method: 'GET',
        }),
      );
      setDocs(docsResponse);
    }
    setOpen(true);
  };

  return (
    <>
      {open && (
        <GraphApiDocumentationModal
          docs={docs}
          onClose={() => {
            setOpen(false);
          }}
        />
      )}
      <GraphToolbarButton
        title={msgButtons.apiDocumentation}
        onClick={handleClick}
      >
        {loadingState === 'LOADING' ? (
          <div className='graph-save-view__spinner-wrapper'>
            <i className='fa-regular fa-spinner fa-spin fa-fw' />
          </div>
        ) : (
          <CodeIcon
            title={msgButtons.apiDocumentation}
            width={16}
            height={13}
          />
        )}
      </GraphToolbarButton>
    </>
  );
};
